export default "/img_score_50.png";